export enum TenantCategory {
  All = 0,
  Pharmacy = 1,
  //历史遗留问题 Clinic 为诊所
  Clinic = 2,
  // 医院
  hospital = 3,
  // 妇幼保健院
  maternityHealthCenter = 4,
  // 社区卫生服务中心
  communityHealthServiceCenter = 5,
  // 卫生院
  surgery = 6,
  // 疗养院
  nursingHome = 7,
  // 门诊部
  outpatientDepartment = 8,
  // 村卫生室
  villageHealthClinic = 9,
  // 急救中心（站）
  emergencyCenter = 10,
  // 临床检验中心
  clinicalLaboratory = 11,
  // 专科疾病防治机构
  specializedDiseasePreventionAndTreatmentInstitution = 12,
  // 护理院（站）
  nursingStation = 13,
  // 中心（实验室）
  center = 14,
  // 其他
  other = 15,
  // 盲人
  blind = 16,
  // 校医务室
  schoolHos = 17,
}

export const TenantCategories = [
  TenantCategory.All,
  TenantCategory.Pharmacy,
  TenantCategory.Clinic,
  TenantCategory.hospital,
  TenantCategory.maternityHealthCenter,
  TenantCategory.communityHealthServiceCenter,
  TenantCategory.surgery,
  TenantCategory.nursingHome,
  TenantCategory.outpatientDepartment,
  TenantCategory.villageHealthClinic,
  TenantCategory.emergencyCenter,
  TenantCategory.clinicalLaboratory,
  TenantCategory.specializedDiseasePreventionAndTreatmentInstitution,
  TenantCategory.nursingStation,
  TenantCategory.center,
  TenantCategory.other,
  TenantCategory.blind,
  TenantCategory.schoolHos,
]

export function getTenantCategoryName(category: TenantCategory): string {
  switch (category) {
    case TenantCategory.Pharmacy:
      return '药店'
    case TenantCategory.Clinic:
      return '诊所'
    case TenantCategory.hospital:
      return '医院'
    case TenantCategory.maternityHealthCenter:
      return '妇幼保健院'
    case TenantCategory.communityHealthServiceCenter:
      return '社区卫生服务中心'
    case TenantCategory.surgery:
      return '卫生院'
    case TenantCategory.nursingHome:
      return '疗养院'
    case TenantCategory.outpatientDepartment:
      return '门诊部'
    case TenantCategory.villageHealthClinic:
      return '村卫生室'
    case TenantCategory.emergencyCenter:
      return '急救中心（站）'
    case TenantCategory.clinicalLaboratory:
      return '临床检验中心'
    case TenantCategory.specializedDiseasePreventionAndTreatmentInstitution:
      return '专科疾病防治机构'
    case TenantCategory.nursingStation:
      return '护理院（站）'
    case TenantCategory.center:
      return '中心（实验室）'
    case TenantCategory.other:
      return '其他'
    case TenantCategory.blind:
      return '盲人机构（含定制功能）'
    case TenantCategory.schoolHos:
      return '校医务室'
    default:
      return '全部'
  }
}
export enum platformType {
  HYD = 0,
  JW = 1,
}

export const platformTypes = [platformType.HYD, platformType.JW]

export function getPlatformTypeName(num: platformType): string {
  switch (num) {
    case platformType.HYD:
      return '好医点'
    case platformType.JW:
      return '聚网'
    default:
      return '-'
  }
}
export enum teantType {
  XY = 0,
  ZY = 1,
  KQ = 2,
  YM = 3,
  YK = 4,
  TY = 5,
  QT = 6,
  ZK = 7,
  // ZW = -1,
}

export const teantTypes = [
  teantType.XY,
  teantType.ZY,
  teantType.KQ,
  teantType.YM,
  teantType.YK,
  teantType.TY,
  teantType.QT,
  teantType.ZK,
  // teantType.ZW,
]

export function getTeantTypeName(teant: teantType): string {
  switch (teant) {
    case teantType.XY:
      return '西医'
    case teantType.ZY:
      return '中医'
    case teantType.KQ:
      return '口腔'
    case teantType.YM:
      return '医美'
    case teantType.YK:
      return '眼科'
    case teantType.TY:
      return '通用'
    case teantType.ZK:
      return '专科'
    case teantType.QT:
      return '其他'
    default:
      return '-'
  }
}

export enum TenantLevel {
  Level1 = 1,
  Level2 = 2,
  Level3 = 3,
  Level4 = 4,
  Level5 = 5,
  Level6 = 6,
}

export const TenantLevels = [
  TenantLevel.Level1,
  TenantLevel.Level2,
  TenantLevel.Level3,
  TenantLevel.Level4,
  TenantLevel.Level5,
  TenantLevel.Level6,
]

export const TenantLevelNames = [
  '一级',
  '二级',
  '三级',
  '四级',
  '五级',
  '未定级',
]

export function getTenantLevelName(level: TenantLevel): string {
  if (level <= 0 || level > TenantLevels.length) {
    return ''
  }
  return TenantLevelNames[level - 1]
}

export const HospitalLevels = [
  TenantLevel.Level1,
  TenantLevel.Level2,
  TenantLevel.Level3,
  TenantLevel.Level6,
]

export interface Tenant {
  trialFlag?: any
  isGray?:any
  versionName?: any
  versionId?: any
  id: string
  name: string
  shortName: string
  status: number
  tenantCategory: TenantCategory
  tenantPhone: string
  hospitalCode: string
  legalPerson: string
  licenceCategory: string
  licenceDeadline: string
  licenceNumber: string
  managerCompany: string
  medicalOrganCode: string
  medicalOrganLevel: number
  organCode: number
  organLevel: TenantLevel
  contactName: string
  phone: string
  postcode: string
  address: string
  labelIds: string
  labelList: any[]
  createTime: string
  startTime: string
  endTime: string
  platformId?: string | number
  platformName: string
  registeredFund: string
  nationUniqueCode?: string
  lastLoginTime?: string
  provinceName?: string
  cityName?: string
  countyName?: string
  openType?: number
  provinceCode: string
  cityCode: string
  countyCode: string
  tenantType: number
  signedType: number
  edition?: number
  hosType?: any
  hosDistinctCode?: any
  zcShoperId?: any
  dockingPlatform?: any
  dockingPlatformTenantId?: any
  dockingPlatformTenantKey?: any
  expansionInfoN1?: any
  expansionInfoN2?: any
}

export function fromJson(json: any): Tenant {
  return {
    trialFlag: json.trialFlag?.toString() || '',
    isGray: json.isGray?.toString() || '',
    versionName: json.versionName?.toString() || '',
    versionId: json.versionId?.toString() || '',
    id: json.id?.toString() || '',
    name: json.name,
    shortName: json.shortName,
    status: json.status,
    tenantCategory: json.tenantCategory,
    tenantPhone: json.tenantPhone,
    hospitalCode: json.hospitalCode,
    legalPerson: json.legalPerson,
    licenceCategory: json.licenceCategory,
    licenceDeadline: json.licenceDeadline,
    licenceNumber: json.licenceNumber,
    managerCompany: json.managerCompany,
    medicalOrganCode: json.medicalOrganCode,
    medicalOrganLevel: json.medicalOrganLevel,
    organCode: json.organCode,
    organLevel: json.organLevel,
    contactName: json.contactName,
    phone: json.phone,
    postcode: json.postCode,
    address: json.address,
    labelIds: json.labelIds,
    labelList: json.labelList,
    createTime: json.createTime,
    startTime: json.startTime,
    endTime: json.endTime,
    registeredFund: json.registeredFund == -1 ? '' : json.registeredFund,
    nationUniqueCode: json.nationUniqueCode,
    provinceName: json.provinceName,
    cityName: json.cityName,
    countyName: json.countyName,
    openType: json.openType,
    platformId: json.platformId,
    platformName: json.platformName,
    provinceCode: json.provinceCode,
    cityCode: json.cityCode,
    countyCode: json.countyCode,
    tenantType: json.tenantType,
    signedType: json.signedType,
    lastLoginTime: json.lastLoginTime,
    edition: json.edition,
    hosType: json.hosType,
    hosDistinctCode: json.hosDistinctCode,
    zcShoperId: json?.zcShoperId,
    dockingPlatform: json?.dockingPlatform,
    dockingPlatformTenantId: json?.dockingPlatformTenantId,
    dockingPlatformTenantKey: json?.dockingPlatformTenantKey,
    expansionInfoN1: json?.expansionInfoN1,
    expansionInfoN2: json?.expansionInfoN2,
  }
}

export function toJson(tenant: Tenant): any {
  return {
    trialFlag: tenant.trialFlag,
    isGray : tenant.isGray,
    versionName: tenant.versionName,
    versionId: tenant.versionId,
    id: tenant.id,
    name: tenant.name,
    shortName: tenant.shortName,
    status: tenant.status,
    tenantCategory: tenant.tenantCategory,
    hospitalCode: tenant.hospitalCode,
    legalPerson: tenant.legalPerson,
    tenantPhone: tenant.tenantPhone,
    licenceCategory: tenant.licenceCategory,
    licenceDeadline: tenant.licenceDeadline,
    licenceNumber: tenant.licenceNumber,
    managerCompany: tenant.managerCompany,
    medicalOrganCode: tenant.medicalOrganCode,
    medicalOrganLevel: tenant.medicalOrganLevel,
    organCode: tenant.organCode,
    organLevel: tenant.organLevel,
    contactName: tenant.contactName,
    phone: tenant.phone,
    postCode: tenant.postcode,
    address: tenant.address,
    labelIds: tenant.labelIds,
    labelList: tenant.labelList,
    createTime: tenant.createTime,
    startTime: tenant.startTime,
    endTime: tenant.endTime,
    registeredFund: tenant.registeredFund == '-1' ? '' : tenant.registeredFund,
    nationUniqueCode: tenant.nationUniqueCode,
    provinceName: tenant.provinceName,
    cityName: tenant.cityName,
    countyName: tenant.countyName,
    platformId: tenant.platformId,
    openType: tenant.openType,
    provinceCode: tenant.provinceCode,
    cityCode: tenant.cityCode,
    countyCode: tenant.countyCode,
    tenantType: tenant.tenantType,
    signedType: tenant.signedType,
    lastLoginTime: tenant.lastLoginTime,
    edition: tenant.edition,
    hosType: tenant.hosType,
    hosDistinctCode: tenant.hosDistinctCode,
    zcShoperId: tenant?.zcShoperId,
    dockingPlatform: tenant?.dockingPlatform,
    dockingPlatformTenantId: tenant?.dockingPlatformTenantId,
    dockingPlatformTenantKey: tenant?.dockingPlatformTenantKey,
    expansionInfoN1: tenant?.expansionInfoN1,
    expansionInfoN2: tenant?.expansionInfoN2,
  }
}
